import "./css/CheckBox.css"
const CheckBox = (props) => {
    if(props.checked !== undefined){
        return (
            <>
                <div className="chk-intelaf">
                    <label>
                        <input checked data-ref={props.myreference} className="chk-intelaf-input" type="checkbox" name="radio"  onChange={props.onChange}/>
                            <span className="chk-intelaf-checkmark"></span>
                            <span className="chk-intelaf-texto">{props.Label}</span>
                    </label>
                </div>
            </>
        )
    }else{
        return (
            <>
                <div className="chk-intelaf">
                    <label>
                        <input data-ref={props.myreference} className="chk-intelaf-input" type="checkbox" name="radio"  onChange={props.onChange}/>
                            <span className="chk-intelaf-checkmark"></span>
                            <span className="chk-intelaf-texto">{props.Label}</span>
                    </label>
                </div>
            </>
        )
    }

}
export default CheckBox